const OrdersColumn = [
    {
        title: "Sr No"
    },
    {
        title: "CourierId"
    },
    {
        title: "PickUpAddres"
    },
    {
        title: "PickUpTime"
    },
    {
        title: "DropAddress"
    },
    {
        title: "DropTime"
    },
    {
        title: "Status"
    },
    {
        title: "Track"
    }
];

export default OrdersColumn;